export function bytes(n: number) {
  if (!n) return '0 B';
  const i = Math.min(3, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i === 0 ? 0 : n / 1024 ** i < 10 ? 1 : 0)} ${['B', 'KB', 'MB', 'GB'][i]}`;
}
export function eta(n: number | null) {
  return n === null ? 'A moment…' : n < 1 ? 'Almost there' : n < 60 ? `${Math.ceil(n)} sec left` : `${Math.ceil(n / 60)} min left`;
}
export function safeLink(text: string) {
  try {
    const url = new URL(text.trim());
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
export function haptic() {
  try {
    navigator.vibrate?.(12);
  } catch {}
}
let audio: AudioContext | undefined;
export function unlockSound() {
  try {
    audio ??= new AudioContext();
    if (audio.state === 'suspended') void audio.resume().catch(() => {});
  } catch {}
}
export function chime(enabled: boolean, complete = false) {
  haptic();
  if (!enabled) return;
  try {
    if (!audio || audio.state !== 'running') return;
    const osc = audio.createOscillator(),
      gain = audio.createGain();
    osc.connect(gain);
    gain.connect(audio.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(complete ? 880 : 660, audio.currentTime);
    osc.frequency.exponentialRampToValueAtTime(complete ? 1174 : 880, audio.currentTime + .1);
    gain.gain.setValueAtTime(0, audio.currentTime);
    gain.gain.linearRampToValueAtTime(.055, audio.currentTime + .015);
    gain.gain.exponentialRampToValueAtTime(.001, audio.currentTime + .24);
    osc.start();
    osc.stop(audio.currentTime + .25);
  } catch {}
}
export async function copy(text: string) {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(text);
  const field = document.createElement('textarea');
  field.value = text;
  field.style.position = 'fixed';
  field.style.opacity = '0';
  document.body.append(field);
  field.select();
  const ok = document.execCommand('copy');
  field.remove();
  if (!ok) throw new Error('Copy is unavailable. Select and copy the text manually.');
}

export function friendlyPlatform(platform: string) {
  return platform.replace(/Linux[^·]*/i, 'Linux ').replace(/Mac(?:Intel|Book|intosh| OS X)?[^·]*/i, 'Mac ').replace(/Win(?:32|64|dows)[^·]*/i, 'Windows ').trim();
}
